import type { MockUser } from './types';

export const mockCoach: MockUser = {
    id: 'user-coach-1',
    name: 'Marco Ferri',
    email: 'marco.ferri@swimsuite.it',
    role: 'coach'
};

export const mockAthlete: MockUser = {
    id: 'user-athlete-1',
    name: 'Giulia Bianchi',
    email: 'giulia.bianchi@swimsuite.it',
    role: 'atleta'
};
